module.exports = __webpack_public_path__ + "src/assets/img/share/tips/open/9d09998730b62676ead60450d17bad78.png";